import { createContext, useContext, useState, useEffect } from "react";

const CartCtx = createContext(null);
const KEY = "samara_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (p, qty = 1) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.product_id === p.id);
      if (ex) return prev.map((i) => i.product_id === p.id ? { ...i, qty: i.qty + qty } : i);
      return [...prev, {
        product_id: p.id, sku: p.sku, name: p.name,
        mrp: p.mrp, dp: p.dp, bv: p.sp, qty,
        image: p.image,
      }];
    });
  };
  const remove = (id) => setItems((p) => p.filter((i) => i.product_id !== id));
  const setQty = (id, qty) => setItems((p) => p.map((i) => i.product_id === id ? { ...i, qty: Math.max(1, qty) } : i));
  const clear = () => setItems([]);
  const subtotal = items.reduce((s, i) => s + (i.mrp * i.qty), 0);
  const totalBv = items.reduce((s, i) => s + (i.sp * i.qty), 0);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartCtx.Provider value={{ items, add, remove, setQty, clear, subtotal, totalBv, count }}>
      {children}
    </CartCtx.Provider>
  );
}
export const useCart = () => useContext(CartCtx);
